// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"293":"7a5d01a7","321":"6fd5b2c1"}[chunkId] + ".chunk.css";
};